import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { ItemItemRevisionPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ItemProductCategoryModel {
    itemId: number
    productCategoryId: number
}

const AddProductCategoryPopup: React.FC<ItemItemRevisionPopupProps> = ({ show, onHide, itemId, itemRevisionId, itemTypeId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<ItemProductCategoryModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ItemProductCategoryModel>({
        itemId: itemId,
        productCategoryId: 0
    });

    const productCategories = useSelectListOptions('api/v1/selectlist/ProductCategoryNameTreeLeaves?activeOnly=true&itemTypeId=' + itemTypeId, '-- Select category');

    function submit() {
        if (formData) {
            DataService
                .create<ItemProductCategoryModel>(`api/v1/ItemProductCategories`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'productCategoryId', label: 'Category', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add category'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('productCategoryId')} options={productCategories} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddProductCategoryPopup;